<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Πίνακας Σχέσεων Εργασίας</h4>
            <p class="card-title-desc">Όλες οι Σχέσεις Εργασίας</p>
            <b-alert
              v-show="alertSchema.show"
              show
              dismissible
              :variant="alertSchema.alertVariant"
              >{{ alertSchema.alertMsg }}</b-alert
            >
            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th>A/A</th>
                    <th>Τίτλος</th>
                    <th v-if="is_staff">Ενέργειες</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(relation, index) in relationships" :key="index">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ relation.title }}</td>

                    <td>
                      <i
                        class="mdi mdi-pencil"
                        @click.prevent="$bvModal.show(`Rel${relation.id}`)"
                      ></i>
                      <i
                        class="mdi mdi-trash-can"
                        @click.prevent="confirm(relation.id)"
                      ></i>

                      <b-modal
                        :id="`Rel${relation.id}`"
                        title="Επεξεργασία σχέση εργασίας"
                        centered
                        hide-footer
                      >
                        <FormModal
                          cardTitle="Επεξεργασία σχέση εργασίας"
                          description=""
                          :value="relation.title"
                          action="update"
                          :relationID="relation.id"
                          @formData="parseFormData"
                        ></FormModal>
                      </b-modal>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <button class="btn btn-primary" v-b-modal.addRelation>
          Προσθήκη
        </button>
        <b-modal
          id="addRelation"
          title="Προσθήκη νέα σχέση εργασίας"
          centered
          hide-footer
        >
          <FormModal
            cardTitle="Προσθήκη σχέση εργασίας"
            description="Εισάγετε ένα νέο όνομα"
            value=""
            action="add"
            @formData="parseFormData"
          >
          </FormModal>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../../api/session";
import FormModal from "./form-modal.vue";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Σχέσεις εργασίας",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, FormModal },
  data() {
    return {
      title: "Σχεσεις εργασιας",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Σχέσεις εργασίας",
          active: true,
        },
      ],
      relationships: [],
      alertSchema: {
        alertVariant: "",
        show: false,
        alertMsg: "",
      },
    };
  },
  mounted() {
    this.fetchRelations();
  },
  computed: {
    ...mapGetters("auth", ["userLoggedIn", "is_staff"]),
  },
  methods: {
    fetchRelations() {
      session.get("api/emplooyement-relationship/").then((resp) => {
        this.relationships = resp.data;
      });
    },
    parseFormData(value, action, relationID) {
      if (action === "update") {
        console.log(value);
        this.$bvModal.hide(`Rel${relationID}`);
        session
          .put(`api/emplooyement-relationship/${relationID}/update/`, {
            title: value,
          })
          .then(() => {
            this.alertSchema = {
              alertVariant: "success",
              alertMsg: "Η σχέση εργασίας ανανεώθηκε",
              show: true,
            };

            this.fetchRelations();
            setTimeout(() => {
              this.alertSchema.show = false;
            }, 2000);
          })
          .catch((e) => {
            console.log(e.response.data);
          });
      } else if (action === "add") {
        session
          .post("api/emplooyement-relationship/create/", {
            title: value,
          })
          .then(() => {
            this.alertSchema = {
              alertVariant: "success",
              alertMsg: "Η σχέση εργασίας καταχωρήθηκε",
              show: true,
            };
            this.fetchRelations();
            this.$bvModal.hide("addRelation");
            setTimeout(() => {
              this.alertSchema.show = false;
            }, 2000);
          })
          .catch((e) => {
            console.log(e.response.data);
          });
      }
    },
    deleteRelation(relation) {
      session
        .delete(`api/emplooyement-relationship/${relation}/delete/`)
        .then(() => {
          this.fetchRelations();
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    confirm(relation) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          this.deleteRelation(relation);
          Swal.fire(
            "Διαγράφηκε!",
            "Η σχέση εργασία σας έχει διαγραφεί.",
            "success"
          );
        }
      });
    },
  },
};
</script>

<style scoped>
.mdi-pencil {
  padding: 10px;
  color: rgb(224, 151, 15);
  transition: all 0.4s;
  margin-right: 5px;
}
.mdi-trash-can {
  color: red;
  padding: 10px;
  transition: all 0.6s;
}
.mdi-pencil {
  color: rgb(224, 151, 15);
  cursor: pointer;
  font-size: 20px;
}
.mdi-trash-can {
  color: red;
  cursor: pointer;
  font-size: 20px;
}
</style>
